<div *ngIf="ready" fxLayout="row" fxLayoutAlign="center center" ngClass.xs="mobile-size-mt-20" ngClass.md="mobile-size-mt-20">
  <div fxLayout="row" fxFlex="100%" fxFlex.sm="80%" fxFlex.md="80%" fxFlex.xs="100%" fxLayoutAlign="center stretch" fxLayoutGap="20px">    
		<mat-card fxLayout="row wrap" fxFlex.xl="1500px" fxFlex.md="100%" fxFlex.xs="100%" fxLayoutAlign="center stretch" ngClass.xs="mobile-size-mt-10" ngClass.md="mobile-size-mt-10" class="mat-elevation-z-sides">
      <img mat-card-image name="header-course-img" class="header-img" src={{courseIconPath}} alt="WEST – Digital Literacy">
      <mat-card-content fxFlex.xs="90%" fxFlex="90%" fxLayout="column" fxLayoutAlign="space-around stretch" ngClass.xs="mobile-size-mt-20" ngClass.md="mobile-size-mt-20">
				<ng-container>
					<h1 class="pt-20"><strong><span>{{courseName | translateDynamic}}</span></strong></h1>
					<div class="initial-assessment-welcome">
						<app-audio [src]="welcomeENPath" [autoplay]="true" (onForceMute)="forceMute = $event" [queue]="defaultQueue"
						[forcePause]="forcePause" (onForcePause)="forcePause = $event"
						></app-audio>
						<h3 i18n="@@ia-user-header" name="user-header">Welcome, {{userFirstName + ' ' + userLastName}}.</h3>
						<br />
	
						<p i18n="@@ia-welcome-sa-1" name="ia-welcome-sa-1">
							Before you start your learning, you need to complete
							a self-assessment in Digital Literacy.
						</p>
						<p i18n="@@ia-welcome-2" name="ia-welcome-2">
							The results will help us find out what you can do
							already and where you can improve.
						</p>
					</div>
					<mat-card class="dig-lit-mat-card" class="mt-20" class="stepper-container" ngClass.xs="mobile-size-mt-10" ngClass.md="mobile-size-mt-10">
							<mat-horizontal-stepper fxHide.xs fxHide.sm fxHide.md fxShow.lg fxShow.xl [linear]="true" #stepperHorizontal>
								<ng-container *ngFor="let stem of result.stems">
									<mat-step>
											<div fxLayout="row wrap" fxLayoutAlign="center center">
													<mat-card-content fxFlex="90%" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="20px">
															<ng-template matStepLabel name="step-dig-lit-stem" class="stepper-title" >
																<span *ngIf="isWelsh">{{stem.nameCy}}</span>
																<span *ngIf="!isWelsh">{{stem.name}}</span>

																<span *ngIf="isWelsh" (click)="$event.stopPropagation()" 
																	(mousedown)="$event.stopPropagation()"
																	class="pl-1 stem-tooltip material-icons fs-14" 
																	[matTooltip]="isWelsh ? stem.tooltipCy : stem.tooltip"
																	(mouseenter)="playAudio(assetsPath + stem.tooltipCyPath )"
																	(mouseleave)="stopAudio()"
																	>info</span>

																<span *ngIf="!isWelsh" (click)="$event.stopPropagation()" 
																	(mousedown)="$event.stopPropagation()"
																	class="pl-1 stem-tooltip material-icons fs-14" 
																	[matTooltip]="isWelsh ? stem.tooltipCy : stem.tooltip"
																	(mouseenter)="playAudio(assetsPath + stem.tooltipPath )"
																	(mouseleave)="stopAudio()"
																	>info</span>
															</ng-template>     
															<ng-container *ngTemplateOutlet="defaultTemplate; context: stem"></ng-container>
													</mat-card-content>
											</div> 
									</mat-step>									
								</ng-container>
							</mat-horizontal-stepper>
				
							<mat-vertical-stepper fxShow.xs fxShow.sm fxShow.md fxHide.lg fxHide.xl [linear]="true" #stepperVertical ngClass.xs="mobile-size-mt-15" ngClass.md="mobile-size-mt-15">
								<ng-container *ngFor="let stem of result.stems">									
									<mat-step ngClass.xs="mobile-size-mt-20" ngClass.md="mobile-size-mt-20">
										<div fxLayout="row wrap" fxLayoutAlign="center center" ngClass.xs="mobile-size-mt-10" ngClass.md="mobile-size-mt-10">
											<mat-card-content fxFlex="90%" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="20px">
												<ng-template matStepLabel name="step-dig-lit-stem" class="stepper-title">
													<span *ngIf="isWelsh">{{stem.nameCy}}</span>
													<span *ngIf="!isWelsh">{{stem.name}}</span>
													
													<span *ngIf="isWelsh" (click)="$event.stopPropagation()" 
														class="pl-1 stem-tooltip material-icons fs-14" 
														[matTooltip]="stem.tooltipCy"
														(mouseenter)="playAudio(assetsPath + stem.tooltipCyPath)"
														(mouseleave)="stopAudio()"
														>info</span>
													<span *ngIf="!isWelsh" (click)="$event.stopPropagation()" 
														class="pl-1 stem-tooltip material-icons fs-14" 
														[matTooltip]="stem.tooltip"
														(mouseenter)="playAudio(assetsPath + stem.tooltipPath)"
														(mouseleave)="stopAudio()"
														>info</span>
												</ng-template>
												<ng-container *ngTemplateOutlet="defaultTemplate; context: stem"></ng-container>
											</mat-card-content>
										</div> 
									</mat-step>
								</ng-container>
							</mat-vertical-stepper> 
					</mat-card>
				</ng-container>
				<app-browser-note ngClass.xs="mt-20" ngClass.md="mt-20"></app-browser-note>
			</mat-card-content>
		</mat-card>
	</div>
</div>

<ng-template #defaultTemplate let-questions="questions" let-stemName="name" let-stemId="id">
	<form fxLayout="column" *ngIf="questions != undefined">
		<mat-accordion [multi]="true">
			<ng-container *ngFor="let question of questions">
				<ng-container *ngIf="question.type == questionModeMultiple">
					<mat-card appearance="outlined">
						<mat-card-header class="fs-15 ml-n-15">
							<mat-panel-title fxLayout="row" fxLayoutAlign="center end" class="flex-grow-none">
								<label class="label m-0 mt-20 mb-10" [matTooltip]="isWelsh ? question.tooltipCy : question.tooltip">
									<b><span [innerHTML]="isWelsh ? question.descriptionCy : question.description">
									</span></b>
								</label>
								<app-audio 
								[src]="isWelsh ? question.pathCy : question.path" 
								[queue]="getQueue(question.answers)" 
								[autoplay]="false"
								[forceMute]="forceMute"
								[forcePause]="forcePause" (onForcePause)="forcePause = $event"
								></app-audio>
							</mat-panel-title>
						</mat-card-header>
						<div fxLayout="row" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column" ngClass.xs="m-0" ngClass="ml-30" 
							fxLayoutAlign="space-around" fxLayoutAlign.sm="space-around stretch" fxLayoutGap.sm="0px" 
							fxLayoutAlign.md="space-around stretch" fxLayoutGap.md="0px" fxLayoutAlign.xs="space-around stretch" fxLayoutGap.xs="0px">
							<mat-list class="dig-lit-answers">
								<ng-container *ngFor="let item of question.answers; let last = last; let index = index; count as c">
									<ng-container *ngIf="c == 13 ? index <= 6 : index <= 5">
										<mat-list-item [ngClass]="{'mat-checkbox-disabled' : item.disabled == true}" ngClass.xs="pt-20">
											<mat-checkbox [disabled]="item.disabled" ngClass.xs="fs-14" ngClass.sm="fs-14" ngClass.md="fs-14" name="stem-answers" [checked]="item.value" 
												(change)="toggleCheckbox(question.id, question.type, item.id, item.value, last, stemId);" color="primary">
												
												<span *ngIf="isWelsh" [matTooltip]="item.tooltipCy" 
												ngClass.xs="text-break" 
												ngClass.sm="text-break" 
												ngClass.md="text-break"
												(mouseenter)="item?.tooltipCyPath ? playAudio(assetsPath + item.tooltipCyPath ) : null"
												(mouseleave)="stopAudio()"
												>
												<span [disabled]="item.disabled" [innerHTML]="item.descriptionCy"></span></span>

												<span *ngIf="!isWelsh" [matTooltip]="item.tooltip" 
												ngClass.xs="text-break" 
												ngClass.sm="text-break" 
												ngClass.md="text-break"
												(mouseenter)="item?.tooltipPath ? playAudio(assetsPath + item.tooltipPath ) : null"
												(mouseleave)="stopAudio()"
												>
												<span [disabled]="item.disabled" [innerHTML]="item.description"></span></span>
											</mat-checkbox>
										</mat-list-item>
									</ng-container>
								</ng-container>
							</mat-list>   
							<mat-list class="dig-lit-answers" ngClass.xl="mt-n-50" ngClass.lg="mt-n-50">
								<ng-container *ngFor="let item of question.answers; let last = last; let index = index; count as c">
									<ng-container *ngIf="c == 13 ? index > 6 : index > 5">
										<mat-list-item [ngClass]="{'mat-checkbox-disabled' : item.disabled == true}" ngClass.xs="pt-20">
											<mat-checkbox [disabled]="item.disabled" ngClass.xs="fs-14" ngClass.sm="fs-14" ngClass.md="fs-14" name="stem-answers" [checked]="item.value" 
												(change)="toggleCheckbox(question.id, question.type, item.id, item.value, last, stemId);" color="primary">
												
												<span *ngIf="isWelsh" [matTooltip]="item.tooltipCy" 
												ngClass.xs="text-break" 
												ngClass.sm="text-break" 
												ngClass.md="text-break"
												(mouseenter)="item?.tooltipCyPath ? playAudio(assetsPath + item.tooltipCyPath) : null"
												(mouseleave)="stopAudio()"
												>
												<span [disabled]="item.disabled" [innerHTML]="item.descriptionCy"></span></span>

												<span *ngIf="!isWelsh" [matTooltip]="item.tooltip" 
												ngClass.xs="text-break" 
												ngClass.sm="text-break" 
												ngClass.md="text-break"
												(mouseenter)="item?.tooltipPath ? playAudio(assetsPath + item.tooltipPath) : null"
												(mouseleave)="stopAudio()"
												>
												<span [disabled]="item.disabled" [innerHTML]="item.description"></span></span>

											</mat-checkbox>
										</mat-list-item>
									</ng-container>
								</ng-container> 
							</mat-list>        	
							<mat-form-field fxHide.xs fxFlex="100%" class="hidden">
									<mat-label>Hidden</mat-label>
									<input matInput>
							</mat-form-field>
						</div>
					</mat-card>
					<br/>
				</ng-container>
				<ng-container *ngIf="question.type == questionModeSlider">
					<mat-card appearance="outlined">
						<mat-card-header class="fs-15 ml-n-15">
							<mat-panel-title fxLayout="row" fxLayoutAlign="center end" class="flex-grow-none">
								<label class="label m-0 mt-20 mb-10" [matTooltip]="isWelsh ? question.tooltipCy : question.tooltip">
									<b><span [innerHTML]="isWelsh ? question.descriptionCy : question.description"></span></b>
								</label>
								<app-audio 
								[forcePause]="forcePause" (onForcePause)="forcePause = $event"
								[src]="isWelsh ? question.pathCy : question.path" 
								[queue]="getQueue(question.answers)" 
								[autoplay]="false"
								[forceMute]="forceMute"
								></app-audio>
							</mat-panel-title>
						</mat-card-header>
						<div class="mt-5" fxLayout="row" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column" ngClass.xs="m-0" ngClass="ml-30" fxLayoutAlign.xs="space-around stretch" fxLayoutGap="30px" fxLayoutGap.xs="0px">	
							<span i18n="@@sa-slider-scale-intructions"><i>Think about your answers on a scale from 1–6, where <b>1</b> is <b>not at all confident</b> and <b>6</b> is <b>very confident</b>. </i></span>
						</div>
						<div ngClass.xs="fs-14" ngClass.sm="fs-14" ngClass.md="fs-14" ngClass.xl="fs-16" class="mt-30 ml-20" fxLayout="column wrap" fxLayoutAlign="center" fxLayoutGap="17px">
							<ng-container *ngFor="let item of question.answers">
								<div fxLayout="row wrap" ngClass.xs="column" ngClass.sm="column" ngClass.md="column">
									<div fxFlex.xl="40" ngClass.xl="slider-answer" ngClass.lg="slider-answer" ngClass.md="slider-answer">
										<span *ngIf="isWelsh" ngClass.xl="text-nowrap" ngClass.xs="text-wrap-wrap" ngClass.md="text-wrap-wrap">{{item.descriptionCy}}</span>
										<span *ngIf="!isWelsh" ngClass.xl="text-nowrap" ngClass.xs="text-wrap-wrap" ngClass.md="text-wrap-wrap">{{item.description}}</span>
									</div>
									<div fxFlex.xl="30" class="slider-input" ngClass.xl="slider-answer" ngClass.lg="slider-answer" ngClass.md="slider-answer" ngClass.sm="slider-answer mt-20" ngClass.xs="slider-answer  mt-20"> 
										<mat-slider min="1" max="6" step="1" ngClass.xs="mat-slider-mobile" ngClass.md="mat-slider-mobile" color="primary"
											discrete [displayWith]="formatLabel" #slider>
											<input matSliderThumb [(ngModel)]="item.value" name="sliderValue-{{item.id}}" (input)="item.value = $event.target.value; item.dirty = true; toggleSlider(stemId); onSliderChange($event);" />
										</mat-slider>
									</div>
									<div fxFlex.xl="30" class="slider-answer-value" ngClass.xl="slider-answer" ngClass.lg="slider-answer" ngClass.md="slider-answer" ngClass.xs="pl-20" ngClass.sm="pl-60">
										<span class="fs-14 slider-value-in-word" [class.new-state]="item.dirty"> <i>{{item.value | convertDigLitSlider}}</i></span></div>
								</div>
							</ng-container>
						</div>
					</mat-card>
				</ng-container>
			</ng-container>
		</mat-accordion>     
		<div fxLayoutAlign="end end" fxLayoutGap="10px" class="pt-20 pb-20">
			<ng-container *ngIf="stemName === categoryDigitalResponsibility">
				<button routerLink="../dashboard" mat-raised-button mat-button name="cancel-button-dig-lit-responsibility" i18n="@@cancel">Cancel</button>
			</ng-container>
			<ng-container *ngIf="stemName !== categoryDigitalResponsibility && stemName !== categoryDigitalCreativity">
				<button mat-raised-button (click)="prevStep(true)" name="back-button-dig-lit" i18n="@@step-button-back">Back</button>
			</ng-container>
			<ng-container *ngIf="stemName !== categoryDigitalCreativity">
				<button mat-raised-button 
					name="next-button-dig-lit-responsibility"
					color="primary"
					(click)="nextStep(true)">
					<span i18n="@@step-button-next">Next</span>
				</button>
			</ng-container>
		</div>
		<ng-container *ngIf="stemName === categoryDigitalCreativity">
			<div fxLayout="row" fxFlexFill fxLayout.lt-sm="column">
				<div fxFlex>				
				<p name="by-clicking-submit" class="by-clicking-submit"><span i18n="@@by-clicking-submit-sa">By clicking "Submit", you will finish the assessment.</span> <br> <span i18n="@@with-above-information-sa">This action cannot be undone.</span></p>				
				</div>
							<div fxLayoutAlign="end end" fxLayoutGap="10px" class="pt-20 pb-20">
									<button mat-raised-button (click)="prevStep(true)" 
											name="back-button-dig-lit" i18n="@@step-button-back">
											Back
									</button>
									<button [disabled]="loader$ | async" mat-raised-button name="dig-lit-submit" color="primary" (click)="submit()">
											<span i18n="@@submit">Submit</span>
									</button>
							</div>
				</div>
		</ng-container>
	</form>
</ng-template>